<template>
  <div class="login">
    <div class="lostSailor-logo">
      <img src="/lostsailor/images/lost.png " alt="" />
    </div>
    <div class="rpc-server-wrapper">
      <RpcServer />
    </div>
    <div id="ual-div"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginService from "../services/LoginService";
import RpcServer from "./RpcServer.vue";
export default {
  name: "Login",
  components: { RpcServer },
  data() {
    return {
      ual: null,
      showPopup: false,
    };
  },
  inheritAttrs: false,
  mounted() {
    localStorage.clear();
    this.handle_login();
    if (this.ual) {
      this.ual.init();
      var [buttonUAL] = document.body.getElementsByClassName("ual-button-gen");
      buttonUAL.click();
      let elements = document.body.getElementsByClassName("ual-button-gen");
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0]);
      }
    } else {
      localStorage.clear();
      const loginService = new LoginService();
      this.ual = loginService.handle_login();
    }
  },
  methods: {
    handle_login: function () {
      if (this.ual) {
        this.ual.init();
        var [buttonUAL] =
          document.body.getElementsByClassName("ual-button-gen");
        buttonUAL.click();
        let elements = document.body.getElementsByClassName("ual-button-gen");
        while (elements.length > 0) {
          elements[0].parentNode.removeChild(elements[0]);
        }
      } else {
        localStorage.clear();
        const loginService = new LoginService();
        this.ual = loginService.handle_login();
      }
    },
  },
};
</script>

<style>
#app {
  height: 100%;
}
.login {
  height: 100%;
  justify-content: space-around;
}
#ual-modal {
  z-index: 1000;
  background: transparent !important;
}
.ual-button-gen {
  display: none !important;
}
#ual-authenticators-list {
  display: flex !important;
  position: relative;
}
.ual-auth-button {
  display: flex !important;
  width: 185px !important;
  margin-right: 10px !important;
  height: 53px;
}

.ual-auth-text {
  display: inline-block !important;
  padding: 20px 4px 17px 10px !important;
  font-size: 10px !important;
  width: 137px !important;
}
#ual-modal-selection-content {
  font-family: "Source Sans Pro", sans-serif;
  background-color: transparent !important;
  border: 1px solid transparent !important;
  margin: 7% auto;
  padding: 30px;
  border-radius: 6px;
  width: 428px !important;
  position: absolute;
  top: 63%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.fa-chevron-right {
  font-size: 16px !important;
  float: right;
  margin: 12px 6px;
}

.ual-modal-content-description {
  color: #fff !important;
  width: 246px !important;
  font-size: 1.2em !important;
  margin: 0.7em auto;
}
.ual-modal-close {
  display: none;
}
</style>